import useTimeZoneClock from 'hooks/useTimeZoneClock';
import moment from 'moment';
import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom';
import { citySelector } from 'slices/citySlice'
import { toCapitalize } from 'views/appointment/view/ViewTable';
import { getBackgroundStyle } from 'components/common/TableColor';
const ViewTable = React.memo(({ item }) => {

    const fields = [
        { label: "US Based Interpreter", name: "us_based", isLocked: 0 },
        { label: "Non US Based Interpreter", name: "non_us_based", isLocked: 0 },
        { label: "English To Target Language", name: "english_to_target", isLocked: 0 },
        { label: "Spanish To Target Language", name: "spanish_to_target", isLocked: 0 },
        { label: "Court Certified", name: "court_certified", isLocked: 0 },
        { label: "Medical Certified", name: "medical_certified", isLocked: 0 },
    ];

    const { city: cities } = useSelector(citySelector);
    // const timeZone = useTimeZoneClock(item?.datetime);
    // const formattedDate = moment(timeZone).format('MMMM DD YYYY, hh:mm A');

    const cityName = React.useMemo(() => {
        const cityName = cities?.find(city => city.id === item?.appointment_details?.facility?.city_id)?.name;
        return cityName;

    }, [item?.facility?.city_id])

    const dynamicFields = React.useMemo(() => {
        const dynamic_fields = item?.appointment_details?.dynamic_fields && JSON.parse(item?.appointment_details?.dynamic_fields) || []
        const dynamicFields = dynamic_fields?.map(field => ({ name: field?.name, value: field?.value }));
        return dynamicFields || [];
    }, [item?.appointment_details?.dynamic_fields])

    const renderTableItem = (title, text) => (
        <>
            <td className='bg-primary-secondary'>
                <h4>{title}</h4>
            </td>
            <td className='bg-primary-secondary'>{text || 'N/A'}</td>
        </>

    )

    const rowDash1Style = {
        display: 'flex',
        alignItems: 'normal',
        width: '100%',
        gap: '1rem'
    };
    const rowDash2Style = {
        display: 'block',
        alignItems: 'normal',
        width: '100%',
        gap: '1rem'
    };
    const marginTopZero = {
        marginTop: 0
    };


    console.log( dynamicFields[0]?.name )
    return (

        <>



            <div className="Table_data_show Table_data_show1 p-0 overflow-auto">
                <div className="row_dash_1" style={rowDash1Style}>
                    <div className="card_table" style={marginTopZero}>

                        <div className="Table_data_show Table_data_show1 pt-0">
                            <table class="bg-primary-secondary table">
                                <tbody>
                                    <tr>
                                        <td class="bg-primary-secondary" style={{ width: "40%" }}>Facility: </td>
                                        <td class="bg-primary-secondary">{item?.appointment_details?.facility?.facility_name}</td>
                                    </tr>
                                    <tr>
                                        <td class="bg-primary-secondary" style={{ width: "40%" }}>Department: </td>
                                        <td class="bg-primary-secondary">{item?.appointment_details?.department?.department_name}</td>
                                    </tr>
                                    <tr>
                                        <td class="bg-primary-secondary" style={{ width: "40%" }}>Address:</td>
                                        <td class="bg-primary-secondary">{item.appointment_details?.facility?.street_address || item.appointment_details?.address}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="interpreter p-4">
                            <h2>Interpreter</h2>
                        </div>
                        <div className="Table_data_show Table_data_show1 pt-0">
                            <table class="bg-primary-secondary table">
                                <tbody>
                                    <tr>
                                        <td class="bg-primary-secondary" style={{ width: "40%" }}>Interpreter Name: </td>
                                        <td className="bg-primary-secondary">
                                            {item?.interpreter?.vendor
                                                ? item?.interpreter?.user?.name + ' - ' + item?.interpreter?.vendor?.name
                                                : item?.interpreter?.user?.name || 'N/A'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="bg-primary-secondary" style={{ width: "40%" }}>Interpreter Email: </td>
                                        <td class="bg-primary-secondary">{item?.interpreter?.user?.email || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td class="bg-primary-secondary" style={{ width: "40%" }}>Interpreter Phone: </td>
                                        <td class="bg-primary-secondary">{item?.interpreter?.phone || 'N/A'}</td>
                                    </tr>

                                    <tr>
                                        <td class="bg-primary-secondary">Checkin Date:</td>
                                        <td class="bg-primary-secondary" colSpan={2}>{item.appointment_assign?.checkin_date || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td class="bg-primary-secondary">Checkin Time:</td>
                                        <td class="bg-primary-secondary" colSpan={2}>{item.appointment_assign?.checkin_time || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td class="bg-primary-secondary">Checkout Date:</td>
                                        <td class="bg-primary-secondary" colSpan={2}>{item.appointment_assign?.checkout_date || 'N/A'}</td>

                                    </tr>
                                    <tr>
                                        <td class="bg-primary-secondary">Checkout Time:</td>
                                        <td class="bg-primary-secondary" colSpan={2}>{item.appointment_assign?.checkout_time || 'N/A'}</td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>

                    </div>
                    <div className="card_table" style={marginTopZero}>
                        <div className="Table_data_show Table_data_show1 pt-0 ">
                            <table class="bg-info-secondary table" style={getBackgroundStyle(item?.status)}>
                                <tbody>
                                    <tr>
                                        <td className="bg-info-secondary" style={{ ...getBackgroundStyle(item?.status), width: "40%" }}>Status: </td>
                                        <td className="bg-info-secondary capitalize-status" style={getBackgroundStyle(item?.status)}>{item?.status}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>



                        <div className="Table_data_show Table_data_show1 pt-0">
                            <table className="bg-primary-secondary table">
                                <tbody>
                                    {fields.map((field, index) => (
                                        <tr key={index}>
                                            <td className="bg-primary-secondary" style={{ width: "40%" }}>
                                                {field.label}
                                            </td>
                                            <td className="bg-primary-secondary">
                                                {item?.appointment_details?.[field.name] === 1
                                                    ? "Yes"
                                                    : item?.appointment_details?.[field.name] === 0
                                                        ? "No"
                                                        : "N/A"}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>


                        <div className="Table_data_show Table_data_show1 pt-0 ">
                            <table class="bg-primary-secondary table">
                                <tbody>
                                    <tr>
                                        <td class="bg-primary-secondary" style={{ width: "40%" }}>Requester Name: </td>
                                        <td class="bg-primary-secondary">{item.appointment_details?.requester_name || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td class="bg-primary-secondary" style={{ width: "40%" }}>Requester Email: </td>
                                        <td class="bg-primary-secondary" toLowerCase={'text-lowercase'}>{item.appointment_details?.requester_email || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td class="bg-primary-secondary" style={{ width: "40%" }}>Requester Phone:</td>
                                        <td class="bg-primary-secondary">{item.appointment_details?.requester_phone || 'N/A'}</td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="row_dash_1" style={rowDash2Style}>
                    <div className="Table_data_show Table_data_show1 pt-0 ">
                        <table class="bg-primary-secondary table">
                            <tbody>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "20%" }}>Estimated Duration: </td>
                                    <td class="bg-primary-secondary" >{item?.estimated_duration || 'N/A'} {item?.estimated_duration_unit || 'N/A'} </td>
                                    <td class="bg-primary-secondary">Rescheduled Reason: </td>
                                    <td class="bg-primary-secondary">{item?.appointment_details?.reschedule_reason || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary">Cancel reason: </td>
                                    <td class="bg-primary-secondary">{item?.appointment_details?.cancel_reason || 'N/A'}</td>
                                    <td class="bg-primary-secondary">Notes:</td>
                                    <td class="bg-primary-secondary">{item.appointment_assign?.notes || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary">DNC Reason:</td>
                                    <td class="bg-primary-secondary">{item?.appointment_details?.dnc_reason || 'N/A'}</td>
                                    <td class="bg-primary-secondary">CNC Reason:</td>
                                    <td class="bg-primary-secondary">{item?.appointment_details?.cnc_reason || 'N/A'}</td>
                                </tr>


                            </tbody>
                        </table>
                    </div>
                </div>


                { ( dynamicFields.length > 0 && dynamicFields[0]?.name !== null)  &&    
                    <div className="row_dash_1" style={rowDash2Style}>
                        <div className="Table_data_show Table_data_show1 pt-0">

                            <table className="bg-primary-secondary table">
                                {item?.id &&
                                    <tbody>
                                        <tr >
                                            {dynamicFields.length > 0 && dynamicFields.map((field, index) => (
                                                renderTableItem(`Dynamic Field ${index + 1}`, `${field.name}: ${field.value || 'N/A' }`)
                                            ))}
                                        </tr>
                                    </tbody>
                                }
                            </table>
                        </div>
                    </div>
                } 

                {item?.type === "In Person" && item?.appointment_custom_pricing && (
                    <>
                        <div className="interpreter p-4">
                            <h2>Custom Appointment Pricing:</h2>
                        </div>

                        <div className="row_dash_1" style={rowDash2Style}>
                            <div className="Table_data_show Table_data_show1 pt-0">
                                <table className="bg-primary-secondary table">
                                    <tbody>
                                        <tr>
                                            <td className="bg-primary-secondary">Mileage (km):</td>
                                            <td className="bg-primary-secondary">{item.appointment_custom_pricing?.mileage ?? '0'}</td>
                                            <td className="bg-primary-secondary">Mileage Rate:</td>
                                            <td className="bg-primary-secondary">
                                                ${Number(item.appointment_custom_pricing?.mileage_rate ?? 0).toFixed(2)}
                                            </td>
                                            <td className="bg-primary-secondary">Mileage Total:</td>
                                            <td className="bg-primary-secondary">
                                                ${Number(item.appointment_custom_pricing?.mileage_total ?? 0).toFixed(2)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="bg-primary-secondary">Travel Hours:</td>
                                            <td className="bg-primary-secondary">{item.appointment_custom_pricing?.travel_hours ?? '0'}</td>
                                            <td className="bg-primary-secondary">Travel Rate:</td>
                                            <td className="bg-primary-secondary">
                                                ${Number(item.appointment_custom_pricing?.travel_rate ?? 0).toFixed(2)}
                                            </td>
                                            <td className="bg-primary-secondary">Travel Total:</td>
                                            <td className="bg-primary-secondary">
                                                ${Number(item.appointment_custom_pricing?.travel_total ?? 0).toFixed(2)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="bg-primary-secondary">Min Duration (hrs):</td>
                                            <td className="bg-primary-secondary">{item.appointment_custom_pricing?.min_duration ?? '0'}</td>
                                            <td className="bg-primary-secondary">Rate per hr:</td>
                                            <td className="bg-primary-secondary">
                                                ${Number(item.appointment_custom_pricing?.duration_rate ?? 0).toFixed(2)}
                                            </td>
                                            <td className="bg-primary-secondary">Session Total:</td>
                                            <td className="bg-primary-secondary">
                                                ${Number(item.appointment_custom_pricing?.session_total ?? 0).toFixed(2)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="bg-primary-secondary" colSpan={5} style={{ textAlign: 'right', fontWeight: 'bold' }}>Subtotal:</td>
                                            <td className="bg-primary-secondary">
                                                ${Number(item.appointment_custom_pricing?.sub_total ?? 0).toFixed(2)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="bg-primary-secondary" colSpan={5} style={{ textAlign: 'right', fontWeight: 'bold' }}>Discount (%):</td>
                                            <td className="bg-primary-secondary">
                                                {(item.appointment_custom_pricing?.discount ?? 0) + '%'}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="bg-primary-secondary" colSpan={5} style={{ textAlign: 'right', fontWeight: 'bold' }}>Appointment Total:</td>
                                            <td className="bg-primary-secondary">
                                                ${Number(item.appointment_custom_pricing?.appointment_total ?? 0).toFixed(2)}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </>
                )}


            </div>


            {/* <div className="Table_data_show overflow-auto">
                <table className="table table-bordered">
                    {item?.id &&
                        <tbody>
                            <tr>
                                {renderTableItem("Appointment ID", item?.appid)}
                                {renderTableItem("Status", toCapitalize(item?.status))}
                            </tr>
                            <tr>
                                {renderTableItem("Date/Time", item?.datetime)}
                                {renderTableItem("Client", item?.accounts?.user?.name || "N/A")}
                            </tr>
                            <tr>
                                {renderTableItem("Appointment Type", item?.type)}
                                {item?.appointment_details?.video_link ? renderTableItem("Video link", <Link to={item?.appointment_details?.video_link}>{item?.appointment_details?.video_link}</Link>) : renderTableItem("Video link", "N/A")}
                            </tr>
                            <tr>
                                {renderTableItem("Language", item?.language?.name)}
                                {renderTableItem("Facility", item?.appointment_details?.facility?.facility_name || 'N/A')}
                            </tr>
                            <tr>
                                {renderTableItem("Department", item?.appointment_details?.department?.department_name)}
                                {renderTableItem("Department Text", item?.appointment_details?.department_text)}
                            </tr>
                            <tr>
                                {renderTableItem("US based", item?.appointment_details?.us_based == 1 ? 'Yes' : "No")}
                                {renderTableItem("Non us based", item?.appointment_details?.non_us_based == 1 ? 'Yes' : "No")}
                            </tr>
                            <tr>
                                {renderTableItem("English to target", item?.appointment_details?.english_to_target == 1 ? 'Yes' : "No")}
                                {renderTableItem("Spanish to target", item?.appointment_details?.spanish_to_target == 1 ? 'Yes' : "No")}
                            </tr>
                            <tr>
                                {renderTableItem("Court certified", item?.appointment_details?.court_certified == 1 ? 'Yes' : "No")}
                                {renderTableItem("Medical certified", item?.appointment_details?.medical_certified == 1 ? 'Yes' : "No")}
                            </tr>
                            <tr>
                                {renderTableItem("Interpreter Name", item?.interpreter?.user?.name || 'N/A')}
                                {renderTableItem("Interpreter Email", item?.interpreter?.user?.email || 'N/A')}
                            </tr>
                            <tr>
                                {renderTableItem("Interpreter Gender", item.appointment_details?.interpreter_gender)}
                                {renderTableItem("Interpreter Notes", item?.appointment_details?.notes)}
                            </tr>
                            <tr>
                                {renderTableItem("Reschedule reason", item?.appointment_details?.reschedule_reason)}
                                {renderTableItem("Cnc reason", item?.appointment_details?.cnc_reason)}
                            </tr>
                            <tr>
                                {renderTableItem("Dnc reason", item?.appointment_details?.dnc_reason)}
                                {renderTableItem("Cancel reason", item?.appointment_details?.cancel_reason)}
                            </tr>
                            <tr>
                                {renderTableItem("Estimated Duration", `${item.estimated_duration} minutes`)}
                                {renderTableItem("Requester Name", item.appointment_details?.requester_name)}
                            </tr>
                            <tr>
                                {renderTableItem("Requester Email", item.appointment_details?.requester_email)}
                                {renderTableItem("Requester Phone", item.appointment_details?.requester_phone)}
                            </tr>
                            <tr>
                                {renderTableItem("Address", item.appointment_details?.address)}
                                {renderTableItem("Auto assign", item?.appointment_details?.auto_assign == 1 ? 'Yes' : "No")}
                            </tr>
                        </tbody>
                    }
                </table>

                <table className="table table-bordered mt-4">
                    {item?.id &&
                        <tbody>
                            <tr>
                                {dynamicFields.length > 0 && dynamicFields.map((field, index) => (
                                    renderTableItem(`Dynamic Field ${index + 1}`, `${field.name}: ${field.value}`)
                                ))}
                            </tr>
                        </tbody>
                    }
                </table>
            </div> */}
        </>
    )

})

export default ViewTable